<div>
	<section id="main" class="bg-light">
		<div
			id="dashboardContainer"
			class="container"
		>
			<div
				class="overlay"
				*ngIf="isLoading || isRedactRecordsLoading"
			>
				<h1 class="heading" [innerHtml]="'Loading' | translator: 'base'">Loading...</h1>
				<img alt="Loading" />
			</div>
			<h1
				[innerHtml]="'navbar_dashboard_link' | translator: 'base'"
			>Dashboard
			</h1>
			<div class="row">
				<div class="col-12">
					<div
						*ngIf="isOnProbation"
						id="probationInformation"
						class="alert alert-danger"
					>
						<h2
							class=""
							[innerHtml]="'probationModalTextOpener' | translator: 'customer'"
						>Your Account Is In Probation.
						</h2>
						<p>
							<strong
								[innerHtml]="'probationStartLabel' | translator: 'customer'"
							>Probation Start Date:</strong> {{ probationStartDate }} 
						</p>
						<p>
							<strong
								[innerHtml]="'probationEndLabel' | translator: 'customer'"
							>Probation End Date:</strong> {{ probationEndDate }} 
						</p>
						<span [innerHtml]="'probationModalText' | translator: 'customer'">
							During the probation period, your company must submit a legible copy of the driver's disclosure and authorization form
							for each PSP record requested. You will be notified via email
							when each driver disclosure and authorization form is accepted and the driver's PSP record is available to view.
						</span>
					</div>

					<ng-template #ErrorSavingModal let-modal>
						<div class="modal-header">
							<h3 
								id="errorSavingModalTitle" 
								class="modal-title"
								[innerHtml]="'Problem' | translator: 'driver'">
								A problem has occurred
							</h3>
						</div>
						<div class="modal-body">
							<p [innerHtml]="'WasError' | translator: 'driver'">
								Please contact the PSP Customer Support Team at 
								<a alt="call customer service" href="tel:8776429499" name="1-877-642-9499">1-877-642-9499</a>. 
								The PSP team is available by phone Monday through Thursday from 8 AM to 6
								PM ET, and on Friday from 8 AM to 5 PM ET.
							</p>
						</div>
						<div class="modal-footer">
							<button class="btn btn-outline-primary"
								[title]="'OK' | translator: 'base'"
								[innerHtml]="'OK' | translator: 'base'"
								name="okay"
								(click)="closeModal()">
								OK
							</button>
						</div>
					</ng-template>

					<a routerLink="/requestRecords" class="btn btn-primary btn-strong"
						[title]="'DashboardRequestButton' | translator: 'customer'" (click)="scrollToTop()" name="btnRecordRequest"
						*ngIf="canRequestRecords" id="btnRecordRequest">
						<span [innerHtml]="'DashboardRequestButton' | translator: 'customer'">Request Driver Records</span>
					</a>
					
					<hr *ngIf="redactRecords != null || isPrimary">
					
					<span>
						<h2 class="h4" [innerHtml]="'mask-heading-primary' | translator: 'mask'">
							PII Masking
						</h2>
					
						<p>
							<b [innerHtml]="'mask-status-label' | translator: 'mask'">Status</b>:
			
							<span *ngIf="redactRecords == null || redactRecords.redactionOn == false" class="text-danger"
								[innerHtml]="'mask-status-disabled-label' | translator: 'mask'">Off</span>
							<span *ngIf="redactRecords && redactRecords.redactionOn == true" class="text-success"
								[innerHtml]="'mask-status-enabled-label' | translator: 'mask'">On</span>
							<br>
							<b [innerHtml]="'mask-effective-date-label' | translator: 'mask'">Effective Date:</b>
							<span *ngIf="redactRecords && redactRecords.modifiedDateTime">
								{{ formatDateTimeWithHourMinute(redactRecords!.modifiedDateTime) }}
							</span>
							<br>
							<b [innerHtml]="'mask-last-updated-by-label' | translator: 'mask'">Last Updated By:</b>
							<span *ngIf="redactRecords && redactRecords.modifiedBy">
								{{ redactRecords!.modifiedBy }}
							</span>

						<p [innerHtml]="'mask-body-primary-1' | translator: 'mask'">
							When enabled, certain personally identifiable information(PII) will be masked (partially hidden) in PSP
							reports:
						</p>
						<ul>
							<li>
								<span [innerHTML]="'mask-example-dob' | translator: 'mask'">
									Driver Date of Birth (DOB) Year (example 01/01/XXXX)
								</span>
							</li>
							<li>
								<span [innerHTML]="'mask-example-cdl' | translator: 'mask'">
									CDL numbers, excluding the last 4 digits (example: XXXXX6789)
								</span>
							</li>
						</ul>
					
						<p *ngIf="isPrimary">
							<button *ngIf="redactRecords == null || redactRecords.redactionOn === false" class="btn btn-link"
								[title]="'mask-button-turn-on' | translator: 'mask'"
								[innerHtml]="'mask-button-turn-on' | translator: 'mask'" (click)="setRecordMasking(true)"
								id="turn-mask-on-1" name="turn-mask-on-1">
								Enable PII Masking
							</button>
							<button *ngIf="redactRecords != null && redactRecords.redactionOn " class="btn btn-link"
								[title]="'mask-button-turn-off' | translator: 'mask'"
								[innerHtml]="'mask-button-turn-off' | translator: 'mask'" (click)="setRecordMasking(false)"
								id="turn-mask-off-1" name="turn-mask-off-1">
								Disable PII Masking
							</button>
					
						</p>
					</span>
					<hr/>
					<h2
						class="h4"
						[innerHtml]="'DashboardYourRecords' | translator: 'customer'"
					>Your Records</h2>

					<p
						[innerHtml]="'DashboardText1' | translator: 'customer'"
					>PSP records are displayed below for <b>5 days (120 hours)</b> from the time of record request.
					</p>
					<p
						[innerHtml]="'DashboardText2' | translator: 'customer'"
					>Each record may be saved or printed. The search field can help you find a specific record.
					</p>
					<p
						[innerHtml]="'DashboardText3' | translator: 'customer'"
					>To request a motor vehicle record (MVR) for a specific state, the MVR by State link found in the top navigation will take you to a list of the motor vehicle record request websites by state.
					</p>

					<app-dashboardgridsearch (emitter)="send($event)" />

					<div class="card shadow-sm rounded-0 border-0 mb-3">
						<div class="card-body">
							<app-dashboardgrid [searchCriteria]="searchCriteria" />
						</div>
					</div>
        			</div>

				<!-- probation mocal -->
				<ng-template #ProbationModal let-modal>
					<div class="modal-header">
						<h3
							id="probationModalTitle" 
							class="modal-title"
							[innerHtml]="'probationModalTitle' | translator: 'customer'"
						>
							Your Account Is In Probation
						</h3>
					</div>
					<div class="modal-body">
						<p
							[innerHtml]="'probationModalTextOpener' | translator: 'customer'"
						>
							Your Account Is In Probation.
						</p>
						<p>
							<strong
								[innerHtml]="'probationStartLabel' | translator: 'customer'"
							>Probation Start Date:</strong> {{ probationStartDate }} 
						</p>
						<p>
							<strong
								[innerHtml]="'probationEndLabel' | translator: 'customer'"
							>Probation End Date:</strong> {{ probationEndDate }} 
						</p>
						<span [innerHtml]="'probationModalText' | translator: 'customer'">
							During the probation period, your company must submit a legible copy of the driver's disclosure and authorization form
							for each PSP record requested. You will be notified via email
							when each driver disclosure and authorization form is accepted and the driver's PSP record is available to view.
						</span>
					</div>
					<div class="modal-footer">
						<button
							class="btn btn-primary"
							[title]="'OK' | translator: 'base'"
							name="okay"
							(click)="dismissProbationModal()"
						>
							<span
								[innerHtml]="'OK' | translator: 'base'"
							>OK</span>
						</button>
					</div>
				</ng-template>
		
			</div>
			<div class="row">
				<div class="col-12 col-md-6 mb-3 mb-md-0"><app-dashboardnews class="h-100" /></div>
				<div class="col-12 col-md-6"><app-dashboardsupport class="h-100" /></div>
			</div>

		</div>
	</section>

	<ng-template #ConfirmMaskingStatusChangeModal let-modal>
          <div class="modal-header">
               <h3 id="confirmMaskingStatusChangeModalTitle" class="modal-title" slot="header"
                    [innerHtml]="'confirmMaskingStatusChangeTitle' | translator: 'mask'">
                    Confirm Masking Status Change
               </h3>
          </div>
          <div class="modal-body">
               <div slot="body" id="confirmMaskingStatusChangeModalText"
                    [innerHtml]="'confirmMaskingStatusChangeModalText' | translator: 'mask'">
                    This change will apply to all future PSP reports requested by your organization.
               </div>
          </div>
          <div class="modal-footer">
               <button class="btn btn-primary" [title]="'OK' | translator: 'base'" name="okay"
                    (click)="completedMaskingStatusChange()">
                    <span [innerHtml]="'OK' | translator: 'base'">OK</span>
               </button>
               <button class="btn btn-outline-primary" [title]="'Cancel' | translator: 'base'" name="cancel"
                    (click)="closeModal()">
                    <span [innerHtml]="'Cancel' | translator: 'base'">Cancel</span>
               </button>
          </div>
     </ng-template>

</div>
